import { render, staticRenderFns } from "./Comp42t2.vue?vue&type=template&id=076a63d2&scoped=true&"
import script from "./Comp42t2.vue?vue&type=script&lang=js&"
export * from "./Comp42t2.vue?vue&type=script&lang=js&"
import style0 from "./Comp42t2.vue?vue&type=style&index=0&id=076a63d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076a63d2",
  null
  
)

export default component.exports